import {
  ColumnLayoutEnum,
  TCardColumnLayoutFields,
  TCardColumnLayoutParams,
  TCardColumnLayoutProps,
  TCardFields,
} from '../types/cardColumnLayout.types';
import { LinkField, StringField, THeadingTag } from '../../../types/types';
import { BACKGROUND_COLOR_MAP } from '../../../constants/background-color.constants';
import { getFollowingHTag } from '../../../utils/seo.utils';

export class CardColumnLayoutModel {
  private readonly fields?: TCardColumnLayoutFields;
  private readonly params?: TCardColumnLayoutParams;

  constructor(props: TCardColumnLayoutProps) {
    this.fields = props?.fields || undefined;
    this.params = props?.params || undefined;
  }

  get backgroundColor(): string | undefined {
    return BACKGROUND_COLOR_MAP.get(this.params?.backgroundColor || '');
  }

  get layout(): string | ColumnLayoutEnum {
    return this.fields?.columnLayout?.fields?.Key?.value || '';
  }

  get title(): StringField | undefined {
    return this.fields?.sectionHeading;
  }

  get eyebrow(): StringField | undefined {
    return this.fields?.sectionEyebrow;
  }

  get subtitle(): StringField | undefined {
    return this.fields?.sectionSubheading;
  }

  get link(): LinkField | undefined {
    return this.fields?.sectionCtaTextLink;
  }

  get cards(): TCardFields[] {
    return this.fields?.items || [];
  }

  get whitetriangle(): StringField | undefined {
    return this.fields?.uiWhiteTriangle;
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }

  get headingTag(): THeadingTag {
    return (this.params?.headingTag?.toLowerCase() as THeadingTag) || 'h3';
  }

  get cardHeadingTitleTag(): THeadingTag {
    return getFollowingHTag(this.headingTag);
  }
}
